import { type CompletionStatus } from "features/Flows/types/enums";
import { isUndefined } from "lodash";
import { CardProgress } from "../../CardProgress/CardProgress";
import { AssetCard, type AssetCardProps } from "../AssetCard/AssetCard";
import { type CardItem } from "../AssetCard/types";

export const ProgressAssetCard = <T extends CardItem & { completionStatus?: CompletionStatus }>(
  props: AssetCardProps<T>,
) => {
  const {
    item: { completionStatus, entityType: type },
    wideBars,
  } = props;

  return (
    <AssetCard
      {...props}
      extraMeta={
        !isUndefined(completionStatus) && (
          <CardProgress completionStatus={completionStatus} wideBars={wideBars} contentType={type} />
        )
      }
    />
  );
};
